import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
import { FaCookieBite } from 'react-icons/fa';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Sprawdzamy, czy w pamięci jest jakakolwiek decyzja (tak lub nie)
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setTimeout(() => {
                setIsVisible(true);
            }, 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true'); // Zapisujemy zgodę
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem('cookieConsent', 'false'); // Zapisujemy brak zgody
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-container">
            <div className="cookie-content">
                <div className="cookie-icon">
                    <FaCookieBite />
                </div>
                <div className="cookie-text">
                    <h3>Dbamy o Twoją prywatność</h3>
                    <p>
                        Ta strona korzysta z plików cookies, aby zapewnić Ci najlepszą jakość korzystania z serwisu. 
                        Możesz zaakceptować wszystkie pliki lub odrzucić te, które nie są niezbędne.
                    </p>
                </div>
            </div>
            
            <div className="cookie-buttons">
                <button className="cookie-btn reject" onClick={handleReject}>
                    Odrzuć
                </button>
                <button className="cookie-btn accept" onClick={handleAccept}>
                    Akceptuję
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;